// extracted by mini-css-extract-plugin
module.exports = {"tooltip-wrap":"tooltip-wrap-5necl","tooltipWrap":"tooltip-wrap-5necl","tooltip-text":"tooltip-text-oTLWg","tooltipText":"tooltip-text-oTLWg"};